import { gatewayUrl } from '@/constant';
import requestDefault from '@/shared/utils/request';
import platform from '@/shared/utils/platform';

/** 钉钉场景，使用钉钉用户三要素置换金融用户 token */
export const dingTalkLogin = (params:{
    ciphertext: string | unknown;
    signData: string | unknown;
    randomKey: string | unknown;
    redirectUrl: string;
    tmpAuthCode?: string | unknown;
}): Promise<{
  data:{
    isGrant: boolean;
    redirectUrl?: string;
    uid: string;
    token: string;
    userId: string;
    expiresIn: number;
    userGuid: string;
    phoneMd5: string;
  }

}> => requestDefault
  .postGate(
    'f.user.dingTalk.loginDingTalkByPhone',
    {
      ...params,
      flowSource: platform.DingTalkFlowSource, // 区分注册来源，写死
    },
    {
      baseURL: gatewayUrl,
      standardResponse: false,
    },
  );

const DingTalkApi = {
  dingTalkLogin,
};

export default DingTalkApi;
